exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-article-tsx": () => import("./../../../src/pages/article.tsx" /* webpackChunkName: "component---src-pages-article-tsx" */),
  "component---src-pages-draft-tsx": () => import("./../../../src/pages/draft.tsx" /* webpackChunkName: "component---src-pages-draft-tsx" */),
  "component---src-pages-microcms-blogs-slug-tsx": () => import("./../../../src/pages/{microcmsBlogs.slug}.tsx" /* webpackChunkName: "component---src-pages-microcms-blogs-slug-tsx" */),
  "component---src-pages-works-tsx": () => import("./../../../src/pages/works.tsx" /* webpackChunkName: "component---src-pages-works-tsx" */)
}

